import React from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import card1 from "../../assets/images/png/card1.png";
import texto1 from "../../assets/images/svg/texto1.svg";
import card2 from "../../assets/images/png/card2.png";
import texto2 from "../../assets/images/svg/texto2.svg";
import card3 from "../../assets/images/png/card3.png";
import texto3 from "../../assets/images/svg/texto3.svg";

export default function CardTexto() {
  const navigate = useNavigate();

  return (
    <div className="card-texto-container pb-5">
      <div className="container">
        <div>
          <div className="d-sm-flex d-none flex-sm-row flex-column justify-content-between">
            <img className="card-texto-content-img py-3" width={"36%"} src={card1} alt="Clawz Entertainment Premium Experience" />
            <img className="card-texto-content-img py-3" width={"56%"} src={texto1} alt="Discover Clawz Entertainment Features" />
          </div>
          <div className="d-flex d-sm-none flex-sm-row flex-column justify-content-between">
            <img className="card-texto-content-img py-3" width={"100%"} src={card1} alt="Clawz Entertainment Premium Experience" />
            <img className="card-texto-content-img py-3" width={"100%"} src={texto1} alt="Discover Clawz Entertainment Features" />
          </div>

          <div className="d-sm-flex d-none flex-sm-row flex-column-reverse justify-content-between">
            <img className="card-texto-content-img py-3" width={"56%"} src={texto2} alt="Clawz Entertainment Benefits" />
            <img className="card-texto-content-img py-3" width={"36%"} src={card2} alt="Clawz Entertainment Special Offers" />
          </div>
          <div className="d-flex d-sm-none flex-sm-row flex-column-reverse justify-content-between">
            <img className="card-texto-content-img py-3" width={"100%"} src={texto2} alt="Clawz Entertainment Benefits" />
            <img className="card-texto-content-img py-3" width={"100%"} src={card2} alt="Clawz Entertainment Special Offers" />
          </div>
          <div className="d-sm-flex d-none flex-sm-row flex-column justify-content-between">
            <img className="card-texto-content-img py-3 scrollClawrranty1" width={"36%"} src={card3} alt="Clawz Entertainment Membership" />
            <img className="card-texto-content-img py-3" width={"56%"} src={texto3} alt="Join Clawz Entertainment Community" />
          </div>
          <div className="d-flex d-sm-none flex-sm-row flex-column justify-content-between">
            <img className="card-texto-content-img py-3 scrollClawrranty2" width={"100%"} src={card3} alt="Clawz Entertainment Membership" />
            <img className="card-texto-content-img py-3" width={"100%"} src={texto3} alt="Join Clawz Entertainment Community" />
          </div>
        </div>
      </div>
    </div>
  );
}
